import { colors } from "@joinTrilo/ui/tokens";
import styled from "styled-components";

export const StyledHeaderWrapper = styled.div`
    width: 100%;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;

    gap: 0.8rem;
    padding: 1.6rem 1.6rem 0.8rem 1.6rem;
`;

export const StyledContent = styled.div`
    position: relative;
    padding: 0 3rem 2rem;

    width: 100%;

    flex: none;
    order: 1;
    flex-grow: 0;
    z-index: 0;

    overflow: hidden;
    overflow-y: auto;
    ::-webkit-scrollbar {
        width: 10px;
        background: transparent;
    }

    ::-webkit-scrollbar-thumb {
        border-right: solid 0.1rem #00bfa5;
        border-radius: 0.2rem;
        height: 6.4rem;
    }

`;

export const StyledFormResponseStatus = styled.div`
    padding: 2rem 3rem;
    font-size: 14px;
    color: ${colors.darkGrey};
`;

export const ReceiptFormContent = styled.div`
    margin: 3rem 0 1rem;
    min - height: 100px;
`;


export const StyledLabel = styled.label`
    display: block;
    border - radius: 0.2rem;
    color: var(--deep - gray);
    font - size: var(--h6);
    transition: 0.2s ease all;
    -moz - transition: 0.2s ease all;
    -webkit - transition: 0.2s ease all;
    margin - bottom: 5px;
`;
